module.exports = __webpack_public_path__ + "img/suppliers.b8db79c9.svg";